export const baseUrl = (window as any)?.__env?.apiUrl;
export const redirectUrl = (window as any)?.__env?.redirectUrl;
